import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
momentDurationFormatSetup(moment)
const SWITCH_PLAYABLE_EXTS = [ '.mov', '.mp4' ]

const getItemStuffs = (itemType, textAppend) => {
	if (textAppend === undefined) textAppend = ''
	if (itemType === 'favorite') {
		return {
			icon: 'star',
			color: 'cyan--text text--accent-4',
			color_icon: 'cyan accent-4',
			text: 'Ajouter aux favoris ' + textAppend
		}
	}
	if (itemType === 'probe') {
		return {
			icon: 'video_settings',
			color: 'light-blue--text text--accent-2',
			color_icon: 'light-blue accent-2',
			text: 'Voir le probe ' + textAppend
		}
	}
	if (itemType === 'open') {
		return {
			icon: 'folder',
			color: 'white--text',
			color_icon: 'white',
			text: 'Ouvrir ' + textAppend
		}
	}
	if (itemType === 'copy') {
		return {
			icon: 'content_copy',
			color: 'green--text text--accent-3',
			color_icon: 'green accent-3',
			text: 'Copier le chemin ' + textAppend
		}
	}
	if (itemType === 'unselect') {
		return {
			icon: 'check_box',
			color: 'pink--text text--lighten-4',
			color_icon: 'pink lighten-4',
			text: 'Désélectionner ' + textAppend
		}
	}
	if (itemType === 'select') {
		return {
			icon: 'check_box_outline_blank',
			color: 'pink--text text--lighten-4',
			color_icon: 'pink lighten-4',
			text: 'Sélectionner ' + textAppend
		}
	}
	if (itemType === 'launcher') {
		return {
			icon: 'play_arrow',
			color: 'primary--text',
			color_icon: 'primary',
			text: 'Lancer une demande de travail ' + textAppend
		}
	}
	if (itemType === 'read') {
		return {
			icon: 'find_in_page',
			color: 'orange--text text--accent-2',
			color_icon: 'orange accent-2',
			text: 'Lire le contenu du fichier (poids <= 1Mo) ' + textAppend
		}
	}
	if (itemType === 'navigate') {
		return {
			icon: 'arrow_forward',
			color: 'deep-purple--text text--lighten-4',
			color_icon: 'deep-purple lighten-4',
			text: 'Naviguer vers ' + textAppend
		}
	}
	if (itemType === 'list') {
		return {
			icon: 'description',
			color: 'orange--text text--accent-2',
			color_icon: 'orange accent-2',
			text: 'Télécharger la liste du contenu ' + textAppend
		}
	}
	if (itemType === 'list_full') {
		return {
			icon: 'description',
			color: 'red--text text--accent-2',
			color_icon: 'red accent-2',
			text: 'Télécharger la liste complète du contenu ' + textAppend
		}
	}
	if (itemType === 'asset_id') {
		return {
			icon: 'image_search',
			color: 'teal--text text--accent-3',
			color_icon: 'teal accent-3',
			text: 'Voir le détail de l\'asset ' + textAppend
		}
	}
	if (itemType === 'mkdir') {
		return {
			icon: 'create_new_folder',
			color: 'pink--text text--accent-2',
			color_icon: 'pink accent-2',
			text: 'Créer un nouveau dossier ' + textAppend
		}
	}
	if (itemType === 'download') {
		return {
			icon: 'download',
			color: 'gray--text text--accent-2',
			color_icon: 'gray accent-2',
			text: 'Télécharger ' + textAppend
		}
	}
	if (itemType === 'view_image') {
		return {
			icon: 'collections',
			color: 'orange--text text--accent-2',
			color_icon: 'orange accent-2',
			text: 'Visualiser ' + textAppend
		}
	}
	if (itemType === 'play') {
		return {
			icon: 'play_arrow',
			color: 'primary--text',
			color_icon: 'primary',
			text: 'Play ' + textAppend
		}
	}
	if (itemType === 'view_html') {
		return {
			icon: 'wysiwyg',
			color: 'orange--text text--accent-2',
			color_icon: 'orange accent-2',
			text: 'Visualiser le rendu HTML ' + textAppend
		}
	}
	return {
		icon: 'circle',
		color: 'white--text',
		color_icon: 'white',
		text: '' + textAppend
	}
}

const pathFormater = (cell) => {
	let rowData = cell.getRow().getData()
	let value = window.vm.$sanitize(
		cell.getValue(),
		{ ALLOWED_TAGS: [], ALLOWED_ATTR: [] }
	)
	let el = ''
	if (rowData.type === 'file') {
		el += '<i style="font-size: 22px" '
		el += 'class="px-1 v-icon material-icons primary--text text--lighten-2">'
		el += 'insert_drive_file</i>'
	}
	el += '<span'
	let classes = []
	if (!rowData.hasOwnProperty('_children')) classes.push('no-child')
	if (rowData.type === 'error') classes.push('error--text')
	if (rowData.type === 'file') classes.push('primary--text text--lighten-2')
	if (classes.length) el += ` class="${classes.join(' ')}"`
	el += `>${value}</span>`
	return el
}

const dateFormatter = (cell) => {
	let date = cell.getValue()
	if (!date) return ''
	return moment(date).format('DD/MM/YY HH:mm')
}

const weight1024Formatter = (cell) => {
	let rowData = cell.getRow().getData()
	if (rowData.type !== 'file') return ''
	let weight = cell.getValue()
	if (isNaN(parseInt(weight))) {
		weight = 'N/A'
	} else {
		if (String(weight).length < 4) {
			weight = weight + ' Oct'
		} else if (String(weight).length >= 4 && String(weight).length < 7) {
			weight = window.vm.$weight.bitRoundToTwo(weight, 1) + ' Kio'
		} else if (String(weight).length >= 7 && String(weight).length < 10) {
			weight = window.vm.$weight.bitRoundToTwo(weight, 2) + ' Mio'
		} else if (String(weight).length >= 10 && String(weight).length < 13) {
			weight = window.vm.$weight.bitRoundToTwo(weight, 3) + ' Gio'
		} else if (String(weight).length >= 13 && String(weight).length < 16) {
			weight = window.vm.$weight.bitRoundToTwo(weight, 4) + ' Tio'
		} else if (String(weight).length >= 16) {
			weight = window.vm.$weight.bitRoundToTwo(weight, 5) + ' Pio'
		} else {
			weight = 'N/A'
		}
	}
	return weight
}

const cellButton = (cell, type) => {
	let rowData = cell.getRow().getData()
	if (rowData.type !== 'folder' && rowData.type !== 'file') return ''
	if (type === 'probe' && rowData.type === 'folder') return ''
	if (type === 'play' && rowData.type !== 'file') return ''
	if (type === 'play' && SWITCH_PLAYABLE_EXTS.indexOf(rowData.ext.toLowerCase()) === -1) return ''
	let btnStuffs = getItemStuffs(type, '')
	return `
		<i style="font-size: 20px" class="v-icon material-icons ${btnStuffs.color}">
			${btnStuffs.icon}
		</i>
	`
}

const selector = (cell) => {
	let row = cell.getRow()
	let rowData = row.getData()
	if (rowData.isSelectable) {
		if (row.isSelected()) {
			return '<i style="font-size: 24px" class="v-icon material-icons primary--text">check_box</i>'
		} else {
			return '<i style="font-size: 24px" class="v-icon material-icons">check_box_outline_blank</i>'
		}
	}
	return '<i style="font-size: 24px" class="v-icon material-icons background--text text--lighten-2">check_box_outline_blank</i>'
}

const headerSelector = (no_select, multiselect) => {
	if (no_select) return ''
	if (!multiselect) return ''
	return '<i style="font-size: 24px" id="multi-selector" class="v-icon material-icons">check_box_outline_blank</i>'
}

const menuItem = (type, meta) => {
	return getItemStuffs(type, meta)
}

const treeExpander = document.createElement('i')
treeExpander.style['font-size'] = '24px'
treeExpander.classList.add('v-icon')
treeExpander.classList.add('material-icons')
treeExpander.classList.add('white--text')
treeExpander.classList.add('px-1')
treeExpander.classList.add('expander')
const treeExpanderName = document.createTextNode('create_new_folder')
treeExpander.appendChild(treeExpanderName)

const treeCollapser = document.createElement('i')
treeCollapser.style['font-size'] = '24px'
treeCollapser.classList.add('v-icon')
treeCollapser.classList.add('material-icons')
treeCollapser.classList.add('white--text')
treeCollapser.classList.add('px-1')
treeCollapser.classList.add('expander')
const treeCollapserName = document.createTextNode('folder')
treeCollapser.appendChild(treeCollapserName)

export default {
	pathFormater,
	dateFormatter,
	cellButton,
	selector,
	headerSelector,
	treeExpander,
	treeCollapser,
	menuItem,
	weight1024Formatter
}



// WEBPACK FOOTER //
// ./src/pages/filesystem/explorer_tabulator_formatters.js